import {AnimatePresence} from '@sail/engine';
import {isComponentType} from './isComponentType';

export function isReactNodeEmptyConsideringAnimatePresence(
  node: React.ReactNode,
): boolean {
  if (isComponentType(node, AnimatePresence)) {
    return !node.props.children && !node.props.emptyRender;
  }

  return !node;
}
